"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _swal = require("sweetalert");
const async_1 = require("./async");
const swal = _swal;
/**Muestra un cuadro de dialogo de si y no */
async function yesno(title, text, type) {
    const result = await swal({
        buttons: true,
        closeOnClickOutside: true,
        closeOnEsc: true,
        title: title,
        icon: type,
        text: text,
    });
    //Nos esperamos a que se cierre por completo, esto porque si no al poner varios dialogos seguidos el evento del mouse de uno se toma tambien para el otro
    await async_1.delay(200);
    return result;
}
exports.yesno = yesno;
/**Muestra un cuadro de dialogo con un mensaje */
async function message(title, text, type) {
    await swal({
        closeOnClickOutside: true,
        closeOnEsc: true,
        title: title,
        icon: type,
        text: text,
    });
    await async_1.delay(200);
}
exports.message = message;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/dialogs.js
// module id = 297
// module chunks = 0